import { ref } from 'vue'
import { getPolicy } from '@/service/common/common'
import { reverseTimestamp } from '@/utils/date-format'
import type {
  ElFile,
  UploadFile
} from 'element-plus/lib/el-upload/src/upload.type'
import { ElUpload } from 'element-plus'

export function useUploadSimple() {
  const uploadRef = ref<InstanceType<typeof ElUpload>>()
  const extraData = ref()
  const files = ref<Array<string>>([])
  const action = ref()
  const filesMap = ref<Map<string, string>>(new Map())
  const beforeUpload = async (file: UploadFile) => {
    const data = await getPolicy()
    const key =
      data.dir +
      reverseTimestamp() +
      file.name.substring(file.name.lastIndexOf('.'))
    extraData.value = {
      ...data,
      OSSAccessKeyId: data.accessId,
      key
    }
    console.log(data)
    action.value = data.host
    files.value.push(data.host + '/' + key)
    if (file instanceof File) {
      filesMap.value.set(String(file.uid), data.host + '/' + key)
    }
  }

  const onSuccess = (response: any) => {
    console.log(response)
  }

  const onExceed = (elFiles: ElFile[]) => {
    uploadRef.value?.clearFiles()
    const file = elFiles[0]
    file.uid = Number(reverseTimestamp())
    files.value = []
    uploadRef.value!.handleStart(file)
    uploadRef.value!.submit()
  }

  return [
    uploadRef,
    extraData,
    files,
    action,
    beforeUpload,
    onSuccess,
    onExceed,
    filesMap
  ]
}
